var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"empty-box"},[_c('img',{staticClass:"empty-img",attrs:{"src":_vm.emptyImg}})])
}
var staticRenderFns = []

export { render, staticRenderFns }